module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp23_7042.a11100d0.png";